import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { FormasPagamentoService } from 'src/app/services/formas-pagamento.service';
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgxMaskDirective } from 'ngx-mask';
declare var $: any;

@Component({
    selector: 'app-payments',
    templateUrl: './payments.component.html',
    styleUrls: ['./payments.component.css'],
    imports: [CommonModule, ReactiveFormsModule, FormsModule, NgxMaskDirective]
})
export class PaymentsComponent implements OnInit {

  modalType: string = 'debito';
  modalStep: string = 'debito_1';
  tabText: string = 'debito';

  loading: boolean = false;


  //Geral
  diasPgto: any[] = [];
  diaPgto: Number;
  assinatura: string = "";
  formaPgtoAtual: any;
  codFormaPgtoAtual: string = "";
  dadosDebitoAtual: any;
  cpfParticipante: string = "";


  //Débito em conta
  formRespFi: FormGroup = null;
  formDebConta: FormGroup = null;
  opcaoTitularidade: string = "minha";
  cpfRespFi: string = '';
  achouRespFi: boolean = false;
  bancosDebitoConta: any[] = [];
  exibiCodOperacao: boolean = false;
  decDebitoConta: boolean = false;
  proximaDataDebitoConta: string = "";

  //Boleto
  decBoleto: boolean = false;
  proximaDataVencBoleto: string;

  //Folha
  decDescontoFolha: boolean = false;
  proximaDataDescFolha: string;

  constructor(private formasPgto: FormasPagamentoService, private toastr: ToastrService) { }

  ngOnInit() {

    this.formRespFi = new FormGroup({
      cpf: new FormControl(null, [Validators.required]),
      nome: new FormControl(null, [Validators.required]),
      celularDDD: new FormControl(null),
      celular: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.email, Validators.required])
    });


    this.formDebConta = new FormGroup({
      banco: new FormControl(null, [Validators.required]),
      operacao: new FormControl(null, []),
      agencia:  new FormControl(null, [Validators.required]),
      conta: new FormControl(null, [Validators.required]),
      contaDV: new FormControl(null, [Validators.required])
    });


    this.carregarCPFParticipante();
    this.buscarFormaPgtoAtual();
    this.buscarDadosDebitoAtual();
    this.listarBancosDebitoConta();

    $('#paymentsModal').on('hidden.bs.modal', ()=>{
      this.formRespFi.reset();
      this.formDebConta.reset();
      this.opcaoTitularidade = "minha";
      this.cpfRespFi = null;

      this.decDebitoConta = false;
      this.decBoleto = false;
      this.decDescontoFolha = false;

      this.assinatura = "";
    });

  }

  buscarFormaPgtoAtual(){

    this.formasPgto
        .buscarFormaPgtoAtual()
        .subscribe(
          (res: any) => {
            this.formaPgtoAtual = res;
            this.codFormaPgtoAtual = res.codFormaPgto;
          },
          (httpError: HttpErrorResponse) => {

          }
        )

  }


  buscarDadosDebitoAtual(){

    this.formasPgto
        .BuscarDadosDebito()
        .subscribe(
          (res: any) => {
            this.dadosDebitoAtual = res;
          },
          (httpError: HttpErrorResponse) => {

          }
        )

  }

  carregarCPFParticipante(){

    this.formasPgto
        .CPFParticipante()
        .subscribe(
          (res: any) => {
            this.cpfParticipante = res;
          },
          (httpError: HttpErrorResponse) => {

          }
        )

  }

  verificarCPFRespFinanceiro(){

    if(this.opcaoTitularidade=="outra"){

      this.formRespFi.get('cpf').setValue(this.cpfRespFi);
      this.formRespFi.get('cpf').disable();

      this.loading = true;

      this.formasPgto
        .VerificarCPFRespFinanceiro(this.limparCpf(this.cpfRespFi))
        .pipe(
          finalize(() => { this.loading=false })
        )
        .subscribe(
          (res: number) => {

            if(res == 1){
              this.modalStep = 'debito_3';
              this.achouRespFi = true;
            }else{
              this.modalStep = 'debito_2';
            }

          },
          (httpError: HttpErrorResponse) => {

          }
        )


    }else{
      this.modalStep = 'debito_3';
    }

  }


  listarDiasPgto(){

    this.formasPgto
        .ListarDiasPgto(this.codFormaPgtoAtual)
        .subscribe(
          (res: any) => {

            this.diasPgto = res;

            if(this.diasPgto.length>0){
              this.diaPgto = this.diasPgto[0].DIA_PGTO;
            }
          },
          (httpError: HttpErrorResponse) => {

          }
        )

  }

  listarBancosDebitoConta(){

    this.formasPgto
        .ListarBancosDebitoConta()
        .subscribe(
          (res: any) => {
            this.bancosDebitoConta = res;

            if(this.bancosDebitoConta.length>0){

              let banco = this.bancosDebitoConta[0].NUM_BANCO;
              this.formDebConta.get('banco').setValue(banco);
              if(banco==104){
                this.exibiCodOperacao=true;
              }

            }

          },
          (httpError: HttpErrorResponse) => {

          }
        )

  }

  onBancoChange(codBanco){
    this.exibiCodOperacao = codBanco==104;
  }

  inserirDebitoConta(){

    if(this.opcaoTitularidade=='outra' && !this.achouRespFi){//Separa o ddd do número do celular

      let celularCompleto: string = this.formRespFi.get("celular").value;

      let ddd = celularCompleto.substr(0, 2);
      let celular = celularCompleto.substr(2, celularCompleto.length);

      this.formRespFi.get('celularDDD').setValue(ddd);
      this.formRespFi.get('celular').setValue(celular);
    }

    let dados = Object.assign({}, this.formDebConta.getRawValue(), this.formRespFi.getRawValue(), {codFormaPgto: 'D', diaPgto: this.diaPgto, assinatura: this.assinatura});
    dados.cpf = this.limparCpf(dados.cpf);

    this.loading = true;

    this.formasPgto
        .AlterarFormaPagamento(dados)
        .pipe(
          finalize(() => { this.loading=false })
        )
        .subscribe(
          (res: any) => {

            this.buscarFormaPgtoAtual();
            this.buscarDadosDebitoAtual();

            this.proximaDataDebitoConta = res.dtaProximaData;
            this.modalStep = 'debito_5';

          },
          (httpError: HttpErrorResponse) => {
            this.toastr.error('Erro: ' + httpError.error.ex);
          }
        )


  }


  inserirBoleto(){

    let dados = {codFormaPgto: 'B', diaPgto: this.diaPgto, assinatura: this.assinatura};

    this.loading = true;

    this.formasPgto
        .AlterarFormaPagamento(dados)
        .pipe(
          finalize(() => { this.loading=false })
        )
        .subscribe(
          (res: any) => {

            this.buscarFormaPgtoAtual();

            this.proximaDataVencBoleto = res.dtaProximaData;
            this.modalStep = 'boleto_3';

          },
          (httpError: HttpErrorResponse) => {
            this.toastr.error('Erro: ' + httpError.error.ex);
          }
        )


  }

  inserirDebitoFolha(){

    let dados = {codFormaPgto: 'F', diaPgto: this.diaPgto, assinatura: this.assinatura};

    this.loading = true;

    this.formasPgto
        .AlterarFormaPagamento(dados)
        .pipe(
          finalize(() => { this.loading=false })
        )
        .subscribe(
          (res: any) => {

            this.buscarFormaPgtoAtual();

            this.proximaDataDescFolha = res.dtaProximaData;
            this.modalStep = 'folha_2';

          },
          (httpError: HttpErrorResponse) => {
            this.toastr.error('Erro: ' + httpError.error.ex);
          }
        )

  }

  public formatarCpf(text: string): string {
    const badchars = /[^\d]/g
    const mask = /(\d{3})(\d{3})(\d{3})(\d{2})/
    const cpf = new String(text).replace(badchars, "");
    return cpf.replace(mask, "$1.$2.$3-$4");
  }

  public limparCpf(text: string): string {
    if(text!=null){
      return text.replace(/\./g, "").replace(/\-/g, "");
    }else{
      return null;
    }
  }

}
